<script>
import entry from '../../entry';
import _7 from './_7.vue';
import _6 from './_6.vue';
import _4 from './_4.vue';

export default entry({
  name: 'setting-shopinfo-entry',
  components: {
    _7,
    _6,
    _4
  },
  map: {
    7: '_7',
    6: '_6',
    4: '_4'
  }
});
</script>
